<template>
    <div>
      <regular-select
        :placeholder="$t('StatusChangeModal.select_placeholder')"
        :value="selectedStatus"
        @change="onStatusSelect($event)">
        <option
          v-for="status in statusMap"
          :value="status.value"
          :key="status.label"
          :class="status.class">
            <p>{{status.label}}</p>
        </option>
      </regular-select>
    </div>
</template>

<script>
import RegularSelect from './regularSelect.vue'

export default {
  name: 'RegularSelectStatus',
  components: {
    RegularSelect
  },

  data () {
    return {
      statusMap: {
        processing: {
          value: 'Processing',
          label: this.$t('Status.processing'),
          class: 'processing'
        },
        dispatch: {
          value: 'Dispatch',
          label: this.$t('Status.dispatch'),
          class: 'dispatch'
        },
        drop: {
          value: 'Drop',
          label: this.$t('Status.drop'),
          class: 'drop'
        },
        pick: {
          value: 'Pick',
          label: this.$t('Status.pick'),
          class: 'pick'
        },
        waiting: {
          value: 'Attente',
          label: this.$t('Status.waiting'),
          class: 'waiting'
        },
        transit: {
          value: 'Transit',
          label: this.$t('Status.transit'),
          class: 'transit'
        },
        inspect: {
          value: 'Inspection',
          label: this.$t('Status.inspection'),
          class: 'inspection'
        },
        transfer: {
          value: 'Transférée',
          label: this.$t('Status.transfered'),
          class: 'transfered'
        },
        reject: {
          value: 'Reject',
          label: `${this.$t('Status.rejected')}`,
          class: 'reject'
        },
        cancel: {
          value: 'Cancel',
          label: `${this.$t('Status.canceled')} !`,
          class: 'cancel'
        },
        finished: {
          value: 'Terminée',
          label: `${this.$t('Status.finished')} !`,
          class: 'terminée'
        }
      },
      selectedStatus: ''
    }
  },

  props: {
    hiddenStatusMap: { // Determines what status' to remove from @statusMap
      type: Array,
      required: false
    }
  },

  created () {
    this.filteredStatusMap()
  },

  methods: {
    onStatusSelect (selectedStatus) {
      this.$emit('emitStatusSelect', selectedStatus)
    },

    /** Some places don't want certain status' to be displayed */
    filteredStatusMap () {
      this.hiddenStatusMap.forEach(status => {
        delete this.statusMap[status.toLowerCase()]
      })
    },

    getStatusMap () {
      return this.statusMap
    }
  }
}
</script>

<style scoped>
</style>
